import { WebApiActionGet, WebApiActionPost, WebApiActionPut, WebApiActionDelete, QueryParams, WebApiItems } from "components/ajax/WebApi";
import rootUrl from "./url";

const baseUrl = rootUrl + "api/faqs";

export interface Faq {
    id: number;
    question: string;
    answer: string;
    isVisible: boolean;
    contact?: string;
    labels: number[];
}



export const apiGetFaqs = function (labelId?: number, showHiddenFaqs: boolean = false): WebApiActionGet<Faq[]> {
    const label = labelId || "";
    return new WebApiActionGet<Faq[]>(baseUrl + `?labelId=${label}&showHiddenFaqs=${showHiddenFaqs}`);
}

export const apiPostFaq = function (): WebApiActionPost<Faq, Faq> {
    return new WebApiActionPost<Faq, Faq>(baseUrl);
}

export const apiPutFaq = function (faqId: number): WebApiActionPut<Faq, Faq> {
    return new WebApiActionPut<Faq, Faq>(`${baseUrl}/${faqId}`);
}

export const apiDeleteFaq = function (faqId: number): WebApiActionDelete<{}, {}> {
    return new WebApiActionDelete<Faq, Faq>(`${baseUrl}/${faqId}`);
}

export const apiSetFaqVisibility = function (faqId: number, visible: boolean): WebApiActionPut<{}, Faq> {
    return new WebApiActionPut<{}, Faq>(`${baseUrl}/${faqId}/set-visibility/${visible}`);
}